<template>
  <status-log-pop-up
    ref="inner"
    title="LOGS"
    :columns="columns"
    :fetch-fn="fetchFn">
    <template #rows="{ data, buildDiffRows }">
      <vs-tr :key="i" v-for="(_, i) in data">

        <vs-td :data="data[i].created_at">
          {{ __dateTimeFormatter(data[i].created_at) }}
        </vs-td>

        <vs-td :data="data[i].event">
          {{ data[i].event }}
        </vs-td>

        <vs-td :data="data[i].causer">
          {{ data[i].causer ? data[i].causer.name : '' }}
        </vs-td>

        <template slot="expand">
          <div class="con-expand-users w-4/5">
            <vs-table v-if="buildDiffRows(data[i].properties).length" noDataText="" class="w-full">
              <template slot="thead">
                <vs-th>CHANGED FIELD</vs-th>
                <vs-th>PREVIOUS VALUE</vs-th>
                <vs-th>NEW VALUE</vs-th>
              </template>
              <template>
                <vs-tr v-for="(row, j) in buildDiffRows(data[i].properties)" :key="j">
                  <vs-td>{{ row.field }}</vs-td>
                  <vs-td>{{ row.old }}</vs-td>
                  <vs-td>{{ row.new }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <p v-else class="text-grey text-sm p-4">No changes recorded for this event.</p>
          </div>
        </template>

      </vs-tr>
    </template>
  </status-log-pop-up>
</template>

<script>
import StatusLogPopUp from '@/components/popups/activity-logs/StatusLogPopUp.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ActivityLogRepository = RepositoryFactory.get('activity')

export default {
  name: 'ViewSalesOrderInvoiceLogPopUp',
  components: { StatusLogPopUp },
  data() {
    return {
      columns: [
        { label: 'DATE/TIME',   width: '25%' },
        { label: 'EVENT TYPE',  width: '25%' },
        { label: 'DONE BY',     width: '50%' },
      ],
      fetchFn: async (id, page, perPage) => {
        const response = await ActivityLogRepository.viewSalesOrderInvoiceLogs(id, page, perPage)
        const result = response && response.data ? response.data : {}
        return { logs: result.data || [], meta: result.meta }
      },
    }
  },
  methods: {
    openPopup(id, code) {
      this.$refs.inner.openPopup(id, { subtitle: code })
    },
  },
}
</script>

<style scoped>
.status-log-pop-up >>> .vs-popup {
  min-width: 70% !important;
}
</style>
